import { Tabs } from "@closer/ui";
import { Outlet, useLocation, useNavigate } from "react-router";

import { useAuth } from "../../lib/authContext";
import { visibleSubscriptionSections } from "../../lib/subscriptionSections";

/**
 * Abonelik ve Kullanım kabuğu (D06 — CLOS-197 `[173]`).
 *
 * `ContractsLayout` ve `OrganizationLayout` deseninin aynısı — yeni bir desen icat
 * edilmedi (refleks 1). Bölümler AYRI ROTALAR, sekme durumu değil: kullanıcı bir sekmeyi
 * bağlantı olarak paylaşabilmeli ve yenilemede bağlam kaybolmamalı.
 *
 * ⚠ Bugün tek bölüm kayıtlı, dolayısıyla sekme çubuğu çizilmiyor. Kartın diğer iki
 * sekmesinin kaynağı henüz yok (`subscriptionSections.ts`'in gerekçesi).
 */
export function SubscriptionLayout() {
  const { can } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const sections = visibleSubscriptionSections(can);

  return (
    <div className="flex w-full flex-col gap-6">
      {/* Tek bölüm görünüyorsa gezinme çizmek anlamsız: tıklanacak bir yer yok. */}
      {sections.length > 1 ? (
        <Tabs
          label="Abonelik ve Kullanım"
          items={sections.map((section) => ({ key: section.key, label: section.label }))}
          activeKey={sections.find((s) => s.route === location.pathname)?.key ?? null}
          onSelect={(key) => {
            const hedef = sections.find((s) => s.key === key);
            if (hedef) void navigate(hedef.route);
          }}
        />
      ) : null}
      <Outlet />
    </div>
  );
}
